import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Products } from '../components/Products';
import { SweetTables } from '../components/SweetTables';
import { Catering } from '../components/Catering';
import { Gallery } from '../components/Gallery';
import { Testimonials } from '../components/Testimonials';
import { Location } from '../components/Location';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function Home() {
  return <div className="w-full min-h-screen bg-white" data-id="element-190">
      <Navbar data-id="element-191" />
      <Hero data-id="element-192" />
      <About data-id="element-193" />
      <Products data-id="element-194" />
      <SweetTables data-id="element-195" />
      <Catering data-id="element-196" />
      <Gallery data-id="element-197" />
      <Testimonials data-id="element-198" />
      <Location data-id="element-199" />
      <Footer data-id="element-200" />
      <WhatsAppButton data-id="element-201" />
    </div>;
}